import { DownloadOutlined } from '@ant-design/icons';
import { MButton } from 'src/lib';
import * as Styles from 'src/lib/ViewDetailsButton/ViewDetailsButton.styles';

export interface DownloadAccountStatementButtonProps {
  onClick: () => void;
  loading: boolean;
}

export const DownloadAccountStatementButton = ({ onClick, loading }: DownloadAccountStatementButtonProps) => {
  return (
    <MButton type='tertiary' className={Styles.viewDetailsButton} onClick={onClick} loading={loading}>
      <DownloadOutlined /> Download
    </MButton>
  );
};
